
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../AppContext';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import LoadingSpinner from '../components/LoadingSpinner';

const SpectatorPage = ({ setView, setSelectedMatch }) => {
    const { db } = useAppContext();
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!db) {
            setLoading(false);
            return;
        }

        const challengesRef = collection(db, 'artifacts/whispers-of-harmony/public/data/challenges');
        const qChallenges = query(challengesRef, where('status', '==', 'playing'));

        // In a real scenario, you'd also query tournament matches.
        // This is simplified for now.
        const unsubChallenges = onSnapshot(qChallenges, (snapshot) => {
            const ongoingChallenges = snapshot.docs.map(doc => ({ id: doc.id, type: 'Challenge Match', ...doc.data() }));
            setMatches(ongoingChallenges);
            setLoading(false);
        }, (err) => {
            setError(err);
            setLoading(false);
        });

        return () => {
            unsubChallenges();
        };
    }, [db]);

    const handleSpectate = (match) => {
        setSelectedMatch(match);
        setView('spectateMatch');
    };

    if (loading) return <LoadingSpinner message="Fetching ongoing matches..." />;
    if (error) return <p className="text-red-500 p-4">Error loading matches.</p>;

    return (
        <div className="w-full h-full bg-gradient-to-b from-slate-900/90 to-black/95 backdrop-blur-xl text-white p-4 md:p-8 flex flex-col overflow-hidden">
            <div className="w-full max-w-4xl mx-auto space-y-4 overflow-y-auto custom-scrollbar pb-20 mt-8">
                {matches.length > 0 ? (
                    matches.map(match => (
                        <div key={match.id} className="bg-gray-800/40 backdrop-blur-md border border-white/10 rounded-xl p-6 flex flex-col md:flex-row items-center justify-between hover:bg-gray-800/60 transition-all shadow-lg group">
                            <div className="mb-4 md:mb-0 md:mr-6 flex-grow text-center md:text-left">
                                <h2 className="text-xl font-bold text-white font-orbitron mb-1">{match.challengerName} <span className="text-gray-500 text-sm mx-2">VS</span> {match.challengedName}</h2>
                                <p className="text-sm text-cyan-300 font-bold uppercase tracking-wider">{match.type}</p>
                                {match.tournamentName && <p className="text-sm text-gray-400 mt-1">Tournament: {match.tournamentName}</p>}
                            </div>
                            <button 
                                onClick={() => handleSpectate(match)}
                                className="w-full md:w-auto px-8 py-3 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 rounded-lg font-bold text-sm transition-all flex-shrink-0 shadow-lg shadow-cyan-500/20 border border-white/10 hover:scale-105"
                            >
                                Watch Live
                            </button>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-24 flex flex-col items-center justify-center">
                        <div className="bg-gray-800/40 p-6 rounded-full mb-4 border border-white/10">
                            <LoadingSpinner size={48} className="text-gray-500" /> 
                        </div>
                        <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gray-200 to-gray-400 font-orbitron">No Live Matches</h2>
                        <p className="text-gray-500 mt-2">The arena is quiet... for now.</p>
                    </div>
                )}
            </div>
        </div>
    );
};
export default SpectatorPage;
